var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileySad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 55.4615385,
    y1: 32.5,
    x2: 67,
    y2: 28,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4BF48",
    cx: 41,
    cy: 41,
    r: 41
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F7D34D",
    cx: 38,
    cy: 40.5,
    rx: 38,
    ry: 37.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#584139",
    cx: 63,
    cy: 28,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#584139",
    cx: 19,
    cy: 28,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,59.5 C60.6160799,55.2025169 58.2827466,52.3691836 56.5,51 C54.8039968,49.697437 54.9200299,49.487668 53,48.5 C48.6875011,46.2816402 43.7768478,45.5 41.5,45.5 C38.3552531,45.5 32.6675855,46.1382172 27.5,50 C25.5892998,51.4278833 22.9226331,54.59455 19.5,59.5",
    id: "Line-4",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileySad);
export default __webpack_public_path__ + "static/media/Smiley_sad.73c2b69c75d49439f94ddbfa8fd5cf36.svg";
export { ForwardRef as ReactComponent };